import * as React from "react";
const SvgFiBrandsHotjar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M21.055 7.814C17.513 1.404 7.118 0 7.118 0s4.798 5.34-1.334 9.567c-3.875 2.666-5.41 6.13-3.75 9.914 1.27 2.899 3.96 4.076 6.861 4.519-.745-1.434-.932-3.505-.381-5.628.055-.212.116-.434.186-.635.813 1.258 2.147 1.946 3.449 1.628 1.783-.424 2.829-2.581 2.342-4.798a5 5 0 0 0-.536-1.372c.07.017.14.023.212.047 2.225.635 3.301 3.962 2.403 7.435a9.3 9.3 0 0 1-1.326 2.945c3.82-1.23 6.361-4.311 7.06-7.056.737-2.857.178-6.186-1.249-8.752"
    />
  </svg>
);
export default SvgFiBrandsHotjar;
